import { Card } from "@mui/material";
import CommonInformation from "../commonInformation";
import CardHeader from "../cardHeader";

export default function CommonDashboardCard({ children, sx = {}, cardHeaderProps = null, hasInfo = false, info = null }) {
  const hasInfoContent = typeof info === 'string'
    ? info.trim().length > 0
    : Boolean(info);

  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "space-between",
        height: '100%',
        border: '1px solid #e5e9f0',
        borderRadius: '10px',
        boxShadow: '0 2px 8px rgba(15, 23, 42, 0.05)',
        backgroundColor: '#ffffff',
        position: "relative",
        ...sx
      }}
    >
      {!!cardHeaderProps && <CardHeader {...cardHeaderProps} />}

      {children}

      {(hasInfo || hasInfoContent) && (
        <CommonInformation info={info} />
      )}
    </Card>
  )
}
